module.exports = __webpack_public_path__ + "img/12c3dfb.jpg";